
export default {
  name: "group_action_dialog",
  props:{showDialog:Boolean, participant:{}, participant_is_admin:false},
  data: () => ({
    group_action_dialog:false,
    participant_data:{},
    action:0
  }),
  computed: {
    userData() {
        return this.$store.getters.userData;
    },
    async getChatgrpList(){
      return await this.$store.getters.getChatgrpList;
    },
    dialog:{
      get:function(){
        return this.showDialog;
      },
      set:function(value){
        this.$emit("dialogClose", value);
      }
    }
  },
  mounted() {
      
  },
  methods: {
    /**
     * participant_profile
     * participant_profile for view participant profile
     */    
    participant_profile(participant_id){
        this.$store.commit('setParticipantId', participant_id);
        this.$router.push({name:"participant_profile"});
    },
    /**
     * group_action_dialog_open
     * Open Group action dialog
     */
    async group_action_dialog_open(participant, action){
      this.participant_data = participant;
      this.action =  action;
      let one_to_one_group  = false;
      if(action == 3){
        let grp_details = await this.getChatgrpList;
        one_to_one_group = this.check_if_one_to_one_group_exists(this.participant_data.participant_id, grp_details);
      }
      
      if(one_to_one_group){
        this.group_action();
      }
      else{
        this.group_action_dialog = true;
      }
      
      this.dialog = false;
    },
    /**
     * 
     * group_action
     * group_action for emited in parent
     */ 
    group_action(){ 
      let participant_id = this.participant_data.participant_id;
      let action = this.action;
      this.$emit('group_action', participant_id, action);
      this.group_action_dialog = false;
    },
    /**
     * check_if_one_to_one_group_exists
     */
    check_if_one_to_one_group_exists(participant_id, grp_details) {
      let one_to_one_group = false;
      grp_details.forEach((group)=>{
          if(group.type == 0){
            if(group.participants && group.participants != null){
              let participants = group.participants.split(',');
              let isPresent = participants.some((id) => {return id === participant_id});
              if(isPresent){
                one_to_one_group = group.group_id;
                return;
              }
            }
          }
      });

      return one_to_one_group;
    }
    
  },/*method closure */
}
